import { Stack } from '@mui/material';
import Input from './Input';
import CustomButton from './Button';
import SaveIcon from '@mui/icons-material/Save';
import PropTypes from 'prop-types';
import { preventChars } from 'utils/utils';
import CheckIcon from '@mui/icons-material/Check';

const MarkupPriceForm = ({
  markupPrice,
  handleSubmit,
  handleMarkupInfo,
  error,
  handleError,
  disableActive,
  disableSave,
  disableComponent
}) => {
  const buttonText = disableSave ? 'Activate' : 'Save and Activate';
  return (
    <form onSubmit={handleSubmit}>
      <Input
        sx={{ marginTop: '2vh', marginLeft: '1vh', mr: '1vh' }}
        type="number"
        placeholder="Enter tier percentage"
        onChange={handleMarkupInfo}
        value={markupPrice}
        required="true"
        label="Tier Percentage"
        disabled={disableComponent}
        onKeyDown={(event) => {
          preventChars(event);
        }}
        inputProps={{
          step: 0.01
        }}
        onFocus={() => handleError('markupPrice', null)}
        name="markupPrice"
        error={error.markupPrice}
      />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        sx={{ mr: '1vh', mb: '-3vh' }}>
        <CustomButton
          disabled={(disableActive && disableSave) || disableComponent}
          type="button"
          endIcon={buttonText === 'Activate' ? <CheckIcon /> : <SaveIcon />}
          onClick={handleSubmit}>
          {buttonText}
        </CustomButton>
      </Stack>
    </form>
  );
};

MarkupPriceForm.propTypes = {
  markupPrice: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleMarkupInfo: PropTypes.func,
  handleError: PropTypes.func,
  error: PropTypes.object,
  disableSave: PropTypes.bool,
  disableActive: PropTypes.bool,
  disableComponent: PropTypes.bool
};

export default MarkupPriceForm;
